// Configurações do sistema - validação via API multi tenancy
// Para adicionar novas configurações, edite o arquivo .config no backend

import { getHeaders } from '../utils/apiUtils';
import env from './env';

/**
 * Verifica se o st_codHashEmpresa está em um parâmetro específico via API
 * @param {string} parametro - Nome do parâmetro (ex: "ALERTACPFCNPJCADCLIENTES")
 * @returns {Promise<boolean>} - Promise que resolve para true se a empresa está na lista, false caso contrário
 */
export const isEmpresaInConfig = async (parametro) => {
  try {
    const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
    
    if (!codHashEmpresa) {
      return false;
    }

    // Chamada para a API de validação do multi tenancy
    // env.API_URL já contém '/api', então não adicionar '/api' novamente
    const response = await fetch(`${env.API_URL}/config/validaparam?VARIAVEL=${parametro}&VALOR=${codHashEmpresa}`, {
      method: 'GET',
      headers: getHeaders(),
    });

    if (!response.ok) {
      return false;
    }

    const data = await response.json();
    return data.resultado === true;
  } catch (error) {
    return false;
  }
};

/**
 * Função de compatibilidade para manter a API existente
 * @param {string} parametro - Nome do parâmetro
 * @returns {Promise<boolean>} - Promise que resolve para true/false
 */
export const validparam = async (parametro) => {
  try {
    return await isEmpresaInConfig(parametro);
  } catch (error) {
    return false;
  }
};

/**
 * Função para obter o valor de um parâmetro específico (se necessário)
 * @param {string} parametro - Nome do parâmetro
 * @returns {Promise<string|null>} - Promise que resolve para o valor do parâmetro ou null
 */
export const getConfigParam = async (parametro) => {
  // Por enquanto, retorna null pois a validação é feita via API
  // Esta função pode ser expandida se necessário
  return null;
}; 